import { Module, PATH_STORE_PROJECT_ASSIGNEES } from "@/constants";
import { StoreProjectAssigneeCreateResponse } from "@/types/storeProjectAssignees";
import { ApiError } from "@/services/api";
import { StoreProjectAssigneeCreate } from "@/types/storeProjectAssignees";
import { useNavigate } from "react-router-dom";
import { useToast } from "@/components/ui/use-toast";
import { useQueryCacheUpdater } from "@/hooks/useQueryCacheUpdater";
import { useTranslation } from "react-i18next";
import { StoreProjectAssigneesService } from "@/services/storeProjectAssignees";
import { useMutationWithErrorHandling } from "@/hooks/useMutationWithErrorHandling";

export const useCreateStoreProjectAssignee = () => {
  const navigate = useNavigate();
  const { toast } = useToast();
  const { invalidateListQuery } = useQueryCacheUpdater(
    Module.StoreProjectAssignees,
  );
  const { t } = useTranslation();

  const mutation = useMutationWithErrorHandling<
    StoreProjectAssigneeCreateResponse,
    ApiError,
    StoreProjectAssigneeCreate,
    unknown
  >({
    mutationFn: (values) => StoreProjectAssigneesService.post(values),
    onSuccess: () => {
      navigate(PATH_STORE_PROJECT_ASSIGNEES);
      toast({
        title: t("storeProjectAssignees.success.create"),
      });
      invalidateListQuery();
    },
    errorTitle: t("storeProjectAssignees.errors.create"),
  });

  return mutation;
};
